import React from "react";
import { Link as ScrollLink } from "react-scroll";

import { Box, Flex, Heading, Spacer, Text, VStack } from "components";

function Content({ title, subtitle, maxWidth }) {
  return (
    <Flex
      data-component-id="homeHero.content"
      position="relative"
      flexDirection="column"
      justifyContent={{ _: "flex-start", lg: "flex-end" }}
      maxWidth={{ _: 256, md: 420, lg: maxWidth }}
      css={{
        //IE11 Fallback
        minHeight: "100vh",
        minHeight: "calc(var(--vh, 1vh) * 100)", // We use CSS variables for this to keep vertical height units static on iOS
      }}
    >
      <Spacer spaceY={{ _: 32 + 32 + 16 + 20 + 64, lg: 48 + 32 + 64 }} />
      <VStack space="layout.3">
        <Box maxWidth="500px">
          <Heading children={title} as="h1" size={900} />
        </Box>
        <Text
          as="p"
          size={500}
          color="brand.secondary"
          style={{ cursor: "pointer" }}
        >
          <ScrollLink children={subtitle} to="home-body" smooth={true} />
        </Text>
      </VStack>
      <Spacer spaceY="layout.5" />
    </Flex>
  );
}

export default Content;
